module.exports = __webpack_public_path__ + "static/assets/81f8ee322cfd8c2f38fb585a709470dd.gif";